<template>
    <div id="login-content" v-if="pageContent && pageContent.length && pageContent[0].contentText!=''" v-html="pageContent[0].contentText"></div>
</template>

<script>
import ContentService from "../services/content.service";
export default {
  name: 'LoginContent',
  props: {
    pageName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pageContent: [],
    };
  },
  mounted() {
    this.getPageContentByPage(this.pageName);
  },
  methods: {
    async getPageContentByPage(page) {
      await ContentService.getPageContentByPage(page, this.getPageContentCallBack, this);
      this.$parent.ready = true;
    },
    getPageContentCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContent = response.data.data;
      }
    }
  }
};
</script>
